// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-selector-conatiner {
  border-bottom: 1px solid #dee2e6;
}
.radio-selector-conatiner .form-check-input {
  cursor: pointer;
}
.radio-selector-conatiner .form-check-label {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/legends/legend-type-selector/legend-type-selector.component.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;AACF;AAAE;EACE,eAAA;AAEJ;AAAE;EACE,eAAA;AAEJ","sourcesContent":[".radio-selector-conatiner {\r\n  border-bottom: 1px solid #dee2e6;\r\n  .form-check-input{\r\n    cursor: pointer;\r\n  }\r\n  .form-check-label{\r\n    cursor: pointer;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
